import type { ReactNode } from "react";
import ErrorBoundary from "./components/ErrorBoundary";
import SiteShell from "./components/SiteShell";
import { ThemeProvider } from "./contexts/ThemeContext";
import { I18nProvider } from "./lib/i18n";

/* Shared provider and layout tree for both prerendering and the route-split
   browser entry. Keeping it page-agnostic lets the client download only the
   active route while the server can still prerender every route in full. */
export default function AppFrame({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="dark">
        <I18nProvider>
          <SiteShell>{children}</SiteShell>
        </I18nProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
